import React from 'react';
import { Image } from '@blueprint/ui';

import { useQuery } from '@apollo/client';
import QUERY_STATIC_GOOGLE_MAP from './StaticGoogleMap.queries';

import { StaticGoogleMapProps } from './StaticGoogleMap.types';
import useStaticGoogleMapURL from './hooks/useStaticGoogleMapURL';

const TEST_ID = 'static-google-map';

const StaticGoogleMap: React.FC<StaticGoogleMapProps> = (props) => {
    const {
        mapSizes,
        responsiveSizes,
        fallbackImgSrc,
        ...restOfImageProps
    } = props;

    const responsiveImgList = useStaticGoogleMapURL(props);

    const { loading, data, error } = useQuery(QUERY_STATIC_GOOGLE_MAP, {
        variables: {
            staticGoogleMapUrls: responsiveImgList.map((item) =>
                encodeURIComponent(item.src)
            )
        }
    });

    if (loading) {
        return null;
    }

    if (error) {
        if (fallbackImgSrc) {
            return (
                <Image
                    data-testid={TEST_ID}
                    src={fallbackImgSrc}
                    title="There was a problem loading the map"
                />
            );
        }

        return <></>;
    }

    // Add signature to each Google map image URL
    const signedUrls = responsiveImgList.map((image, idx) => ({
        ...image,
        src: `${image.src}&signature=${data?.googleMapUrlSignatures?.[idx]}`
    }));

    // Default to high-res image for browsers not supporting responsive srcset
    const src = signedUrls[signedUrls.length - 1].src;

    return (
        <Image
            data-testid={TEST_ID}
            src={src}
            responsiveImgList={signedUrls}
            sizes={responsiveSizes}
            {...restOfImageProps}
        />
    );
};

export default StaticGoogleMap;
